import React from 'react';
import { FadeIn } from './FadeIn';
import { MessageCircleOff, AlertTriangle } from 'lucide-react';
export function PainSection() {
  return <section className="w-full py-24 px-6 bg-white relative" data-id="element-80">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-81">
        <FadeIn data-id="element-82">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-83">
            {/* Column A: Colegio */}
            <div className="bg-gray-50 rounded-3xl p-8 md:p-12 border border-gray-200 relative overflow-hidden flex flex-col h-full" data-id="element-84">
              <div className="absolute top-4 left-6 text-9xl font-playfair text-gray-200 opacity-50 leading-none select-none" data-id="element-85">
                "
              </div>
              <div className="relative z-10 flex flex-col h-full" data-id="element-86">
                <div className="flex items-center gap-3 mb-6" data-id="element-87">
                  <MessageCircleOff className="w-6 h-6 text-gray-400" data-id="element-88" />
                  <h3 className="font-sans font-semibold text-gray-500 uppercase tracking-wider text-sm" data-id="element-89">
                    Lo que el colegio te dice:
                  </h3>
                </div>
                <p className="font-playfair text-3xl md:text-4xl text-gray-400 leading-relaxed italic mt-auto mb-auto" data-id="element-90">
                  "Son cosas de chicos, ya se les va a pasar."
                </p>
              </div>
            </div>

            {/* Column B: Realidad */}
            <div className="bg-creme rounded-3xl p-8 md:p-12 border border-warm-accent/30 shadow-soft relative overflow-hidden flex flex-col h-full" data-id="element-91">
              <div className="absolute -right-10 -bottom-10 w-40 h-40 bg-warm-accent/5 rounded-full blur-3xl" data-id="element-92"></div>
              <div className="relative z-10 flex flex-col h-full" data-id="element-93">
                <div className="flex items-center gap-3 mb-6" data-id="element-94">
                  <AlertTriangle className="w-6 h-6 text-warm-accent" data-id="element-95" />
                  <h3 className="font-sans font-bold text-warm-accent uppercase tracking-wider text-sm" data-id="element-96">
                    La realidad:
                  </h3>
                </div>
                <p className="font-playfair text-3xl md:text-4xl text-dark-coffee leading-relaxed font-semibold mt-auto mb-auto" data-id="element-97">
                  Tu hijo sufre en silencio y se está apagando.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}